import { useQuery } from "@tanstack/react-query"
import {
  getCodigoFacturaRectificativa,
  getFormasCobro,
  getFormasPago,
} from "./Enum.service"

export function useEnumCodigoFacturaRectificativa() {
  const {
    data: codigoFacturaRectificativa,
    isLoading: codigoFacturaRectificativaIsLoading,
  } = useQuery({
    queryKey: ["getCodigoFacturaRectificativaOptions"],
    queryFn: () => getCodigoFacturaRectificativa(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 8,
  })

  return {
    codigoFacturaRectificativa,
    codigoFacturaRectificativaIsLoading,
  }
}

export function useEnumFormasPago() {
  const { data: formasPago, isLoading: formasPagoIsLoading } = useQuery({
    queryKey: ["getFormasPago"],
    queryFn: () => getFormasPago(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 8,
  })

  return {
    formasPago,
    formasPagoIsLoading,
  }
}

export function useEnumFormasCobro() {
  const { data: formasCobro, isLoading: formasCobroIsLoading } = useQuery({
    queryKey: ["getFormasCobro"],
    queryFn: () => getFormasCobro(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 8,
  })

  return {
    formasCobro,
    formasCobroIsLoading,
  }
}
